import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { updatePricing } from "../../../../services/profile";
import { toast } from "react-toastify";
import { setLoading } from "../../../../reducer/auth/auth";
import { useTranslation } from "react-i18next";

export default function Coaching(props) {
  const { t } = useTranslation("mediumPricing");
  const dispatch = useDispatch();
  const { stepOneData, id, onProfileUpdate } = props;
  const { coaching_pricing_30,coaching_pricing_60, session_currency } = stepOneData || {};
  useEffect(() => {
    console.log(stepOneData, "data");
  }, []);
  const updateCoachingPricing = (formData) => {
    dispatch(setLoading(true));
    const { coaching_pricing_30, coaching_pricing_60, session_currency } = formData;
    let item = {
      userId: id,
      coaching_pricing:
      (coaching_pricing_30 === "" ||
      coaching_pricing_30 === null ||
      parseInt(coaching_pricing_30) === 0) &&
      (coaching_pricing_60 === "" ||
      coaching_pricing_60 === null ||
      parseInt(coaching_pricing_60) === 0)
        ? null
        : JSON.stringify({
          30: coaching_pricing_30,
          60: coaching_pricing_60,
        }),
      session_currency: JSON.stringify({
      30: session_currency,
      45: session_currency,
      60: session_currency,
      452: session_currency,
      602: session_currency,
      }),
    };
    updatePricing(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          stepOneData.session_currency = session_currency
          toast.success(t("coaching.updated"), { position: "top-center" });
          if (typeof onProfileUpdate === 'function') {
            onProfileUpdate(); // Call the parent function
          } else {
            console.error('onProfileUpdate is not a function');
          }
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };
  return (
    <div className="pricing-card">
      <Formik
      enableReinitialize
        initialValues={{
          coaching_pricing_30: coaching_pricing_30 || "",
          coaching_pricing_60: coaching_pricing_60 || "",
          session_currency: session_currency || "",
        }}
        onSubmit={(values, actions) => {
          updateCoachingPricing(values);
          actions.setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          handleSubmit,
          isSubmitting,
          setFieldTouched,
        }) => (
          <Form>
            <div className="pricing-card-intro">
              <p className="pricing-card-desc">{t("shared.enterPricing")}</p>
              <div className="pricing-note-box">
                <p className="pricing-note-text">{t("shared.pricingNote")}</p>
              </div>
            </div>

            <div className="pricing-row">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label htmlFor="coaching_pricing_30">{t("durations.min30")}</label>
              </div>
              <div className="pricing-amount-box">
                <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                <Field
                  className="amount_input pricing-amount-input"
                  id="coaching_pricing_30"
                  name="coaching_pricing_30"
                  type="number"
                  placeholder="0.00"
                />
              </div>
              <ErrorMessage
                name="session_length_30"
                component="div"
                className="error"
              />
            </div>

            <div className="pricing-row">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label htmlFor="coaching_pricing_60">{t("durations.min60")}</label>
              </div>
              <div className="pricing-amount-box">
                <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                <Field
                  className="amount_input pricing-amount-input"
                  id="coaching_pricing_60"
                  name="coaching_pricing_60"
                  type="number"
                  placeholder="0.00"
                />
              </div>
              <ErrorMessage name="session_length_60" component="div" className="error" />
            </div>

            <div className="pricing-row pricing-row-currency">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label>{t("shared.sessionCurrency")}</label>
              </div>
              <div className="pricing-currency-group">
                <span className="pricing-currency-pill">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_usd"
                    value={"USD"}
                    checked={values.session_currency === "USD" ? true : false}
                  />
                  <label htmlFor="session_currency_usd">USD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_cad"
                    value={"CAD"}
                    checked={values.session_currency === "CAD" ? true : false}
                  />
                  <label htmlFor="session_currency_cad">CAD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_aud"
                    value={"AUD"}
                    checked={values.session_currency === "AUD" ? true : false}
                  />
                  <label htmlFor="session_currency_aud">AUD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_eur"
                    value={"EUR"}
                    checked={values.session_currency === "EUR" ? true : false}
                  />
                  <label htmlFor="session_currency_eur">EUR</label>
                </span>
              </div>
            </div>

            <div className="pricing-note-box pricing-note-box-footer">
              <p className="pricing-note-text">{t("shared.providerNoteWithPrefix")}</p>
            </div>
            <span className="error text-left">
              {errors.session_currency &&
                touched.session_currency &&
                errors.session_currency}
            </span>

            <div className="pricing-card-footer">
              <button type="submit" className="resend-btn pricing-update-btn">
                {t("shared.submit")}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
